import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';

const propTypes = PropTypes.shape({
  title: PropTypes.string.isRequired,
});

const defaultProps = {};

const BlogTitle = ({ title }) => (
  <h1>{title}</h1>
);

BlogTitle.propTypes = propTypes;
BlogTitle.defaultProps = defaultProps;

BlogTitle.fragments = {
  currentSite: gql`
    fragment BlogTitleCurrentSite on Site {
      blogSettings {
        title
      }
    }
  `,
};

export default BlogTitle;
